export class FbTracker {
    serviceName = 'fb';
    #eventData;

    constructor(eventData) {
        this.#eventData = eventData;
    }

    firePixelEvent(eventName) {
        const eventDataConfig = this.#eventDataConfig();

        if (!eventDataConfig.hasOwnProperty(eventName)) {
            return;
        }

        eventDataConfig[eventName]();
    }

    firePurchaseEvent(price, orderID, currency) {
        this.#triggerEvent(
            'Purchase',
            {
                content_ids: [this.#eventData.name],
                content_name: this.#eventData.name,
                content_type: 'product',
                contents: this.#createContentsProperty(),
                value: price,
                currency,
            },
            orderID,
        );
    }

    fireCheckoutStartedEvent() {
        this.firePixelEvent('checkout_step_1_email_submitted');
    }

    fireAddPaymentInfoEvent(paymentType) {
        this.firePixelEvent('cc_number_entered');
    }

    #triggerEvent(eventName, eventData, eventID) {
        if (typeof fbq !== 'function') {
            return;
        }

        fbq('track', eventName, eventData, { eventID });
    }

    #eventDataConfig() {
        const addPaymentInfoEvent = () => {
            this.#triggerEvent(
                'AddPaymentInfo',
                {
                    content_ids: [this.#eventData.name],
                    content_category: 'online_course',
                    content_type: 'product',
                    contents: this.#createContentsProperty(),
                    value: 0.0,
                    currency: this.#eventData.currency,
                },
                this.#eventData.session_id,
            );
        };

        return {
            first_buy_buttons_are_seen: () => {
                this.#triggerEvent(
                    'ViewContent',
                    {
                        content_ids: [this.#eventData.name],
                        content_category: 'online_course',
                        content_type: 'product',
                        content_name: this.#eventData.name,
                        contents: this.#createContentsProperty(),
                        value: 0.0,
                        currency: this.#eventData.currency,
                    },
                    this.#eventData.session_id,
                );
            },
            checkout_buy_button_is_clicked: () => {
                this.#triggerEvent(
                    'InitiateCheckout',
                    {
                        content_ids: [this.#eventData.name],
                        content_category: 'online_course',
                        content_type: 'product',
                        contents: this.#createContentsProperty(),
                        num_items: 1,
                        value: 0.0,
                        currency: this.#eventData.currency,
                    },
                    this.#eventData.session_id,
                );
            },
            checkout_step_1_email_submitted: () => {
                this.#triggerEvent(
                    'Lead',
                    {
                        content_category: 'online_course',
                        content_name: this.#eventData.name,
                        value: 0.0,
                        currency: this.#eventData.currency,
                    },
                    this.#eventData.session_id,
                );
            },
            cc_number_entered: addPaymentInfoEvent,
            paypal_button_click: addPaymentInfoEvent,
            apple_pay_button_click: addPaymentInfoEvent,
            apple_pay_available: () => {
                this.#triggerEvent(
                    'CustomerProperty',
                    {
                        content_type: 'has_apple_pay_' + this.#eventData.name,
                    },
                    this.#eventData.session_id,
                );
            },
        };
    }

    #createContentsProperty() {
        return [
            {
                id: this.#eventData.name,
                quantity: 1,
            },
        ];
    }
}
